module.exports = __webpack_public_path__ + "static/logo-label@2x-3c84fb16144f4e989b1622f36217c891.png";